/* eslint-disable object-curly-newline */
import attributeApi from '@/api/attribute';
import providerApi from '@/api/provider';
import countryApi from '@/api/country';
// import regionApi from '@/api/region';
import {
  storeActionCommit,
} from '@/utils/common-utils';

export default {
  fetchProviders({ commit }, { type, filters, errorManagementType }) {
    return providerApi.fetchProviders(type, filters, errorManagementType)
      .then(storeActionCommit(commit, 'setProviders'));
  },

  fetchProvider({ commit }, { id, idType, errorManagementType }) {
    idType = idType == null ? 'id' : idType;

    return providerApi.fetchProvider(id, idType, errorManagementType)
      .then(storeActionCommit(commit, 'setProvider'));
  },

  fetchProviderFilters({ commit }, { errorManagementType }) {
    return Promise.all([
      attributeApi.fetchAttributes('PROVIDER', errorManagementType),
      countryApi.fetchCountries('providers', errorManagementType),
      // regionApi.fetchRegions(errorManagementType),
    ]).then((result) => {
      commit('setFilters', {
        attributes: result[0],
        countries: result[1],
        // regions: result[2],
      });
    });
  },
};
